import { Box, Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', p: 3 }}>
      <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center' }}>
        <Typography variant="h1">Página no encontrada</Typography>
        <Typography variant="body2" color="text.secondary">
          La página que busca no existe.
        </Typography>
        <Button component={Link} to="/dashboard" variant="contained">
          Ir a mis formularios
        </Button>
      </Stack>
    </Box>
  );
}
